import * as React from "react";

const Loading = ({ contained, transparent, customTop }) => {
  return (
    <div
      className={
        "xflow-loader" +
        (contained ? " xflow-loader-contained" : "") +
        (transparent ? " xflow-loader-transparent" : "")
      }
      style={customTop ? { "--xflow-loader-top": customTop } : undefined}
      role="status"
      aria-label="Cargando"
    >
      <div className="xflow-loader-card">
        <div className="xflow-loader-mark">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
